import { sendAuthenticatedAsyncRequest } from "services/AsyncRequestService";

/**
 * @param {object} query — camelCase per AiCallLogQueryRequestDto
 * @returns {Promise<{ records: object[], totalElements: number, totalPages: number, page: number, first?: boolean, last?: boolean, empty?: boolean }>}
 *    Mirrors backend `com.razormetrics.commons.util.dto.list.v2.ResponseDto<AiCallLogRowDto>`.
 */
export function fetchAiCallLogPage(query) {
  return new Promise((resolve, reject) => {
    sendAuthenticatedAsyncRequest(
      "/ai-vendor/call-log/list",
      "POST",
      query,
      (res) => resolve(res.data),
      (err) => reject(err)
    );
  });
}

export function buildAiCallLogQuery({
  switchInfoId,
  callGroupTypes,
  outboundCallStatuses,
  switchStatuses,
  outcomeTags,
  outboundPhoneSearch,
  prescriberNpiSearch,
  creationDateFrom,
  creationDateTo,
  updateDateFrom,
  updateDateTo,
  limit,
  offset,
}) {
  const body = { limit, offset };
  if (switchInfoId != null) body.switchInfoId = switchInfoId;
  if (callGroupTypes?.length) body.callGroupTypes = callGroupTypes;
  if (outboundCallStatuses?.length) body.outboundCallStatuses = outboundCallStatuses;
  if (switchStatuses?.length) body.switchStatuses = switchStatuses;
  if (outcomeTags?.length) body.outcomeTags = outcomeTags;
  if (outboundPhoneSearch) body.outboundPhoneSearch = outboundPhoneSearch;
  if (prescriberNpiSearch) body.prescriberNpiSearch = prescriberNpiSearch;
  if (creationDateFrom) body.creationDateFrom = creationDateFrom;
  if (creationDateTo) body.creationDateTo = creationDateTo;
  if (updateDateFrom) body.updateDateFrom = updateDateFrom;
  if (updateDateTo) body.updateDateTo = updateDateTo;
  return body;
}
